import { Entity } from '@backstage/catalog-model';

/**
 * Checks if entity should show PageSpeed tab
 * Shows tab for websites and services that can have performance metrics
 */
export const isPageSpeedAvailable = (entity: Entity): boolean => {
  const entityType = entity?.spec?.type as string;
  // Show PageSpeed tab for websites and services
  return entityType === 'website' || entityType === 'service';
};

/**
 * Checks if entity has Sentry annotations configured
 * Shows Sentry tab if organization and project-slug are present
 */
export const isSentryAvailable = (entity: Entity): boolean => {
  const annotations = entity?.metadata?.annotations || {};
  
  return Boolean(
    annotations['sentry.io/organization'] &&
    annotations['sentry.io/project-slug']
  );
};

